import { useAppContext } from "../../../_context";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import FormGroup from "react-bootstrap/FormGroup";
import FormControl from "react-bootstrap/FormControl";
import Button from "../../Misc/Button";
import Image from "next/image";
import TelephoneInput from "../../TelephoneInput";
import FieldError from "../../FieldError";

const ContactForm = ({ onClick, allErrors, defaultReason = null }) => {
  const [{ tx }] = useAppContext();

  return (
    <section className="d-flex align-items-center py-7 mw-1920 mx-auto">
      <Row className="w-100 m-0">
        <Col
          xs={12}
          md={6}
          className="graphic d-flex justify-content-end align-items-end">
          <div className="graphic-container">
            <Image
              src="/img/contact/help.png"
              width={645}
              height={500}
              unoptimized={true}
            />
          </div>
        </Col>
        <Col xs={12} md={6} className="form-section pt-6 pt-md-0">
          <Row>
            <Col xs={12}>
              <h1 className="h2">{tx["Get in touch"]}</h1>
            </Col>

            <Col lg={6}>
              <FormGroup className="mb-3">
                <label className="form-label" htmlFor="contact-full-name">
                  * {tx["Full name"]}
                </label>
                <FormControl id="contact-full-name" />
              </FormGroup>
              <FieldError fieldName="contact-full-name" allErrors={allErrors} />
            </Col>
            <Col lg={6}>
              <FormGroup className="mb-3">
                <label className="form-label" htmlFor="contact-email">
                  * {tx["Email"]}
                </label>
                <FormControl id="contact-email" />
              </FormGroup>
              <FieldError fieldName="contact-email" allErrors={allErrors} />
            </Col>

            <Col lg={6}>
              <FormGroup className="mb-3">
                <label className="form-label" htmlFor="contact-phone">
                  * {tx["Phone number"]}
                </label>
                <TelephoneInput id="contact-phone" />
              </FormGroup>
              <FieldError fieldName="contact-phone" allErrors={allErrors} />
            </Col>
            <Col lg={6}>
              <FormGroup className="mb-3">
                <label className="form-label" htmlFor="contact-reason">
                  * {tx["Reason"]}
                </label>
                <select
                  id="contact-reason"
                  className="form-control"
                  defaultValue={defaultReason || "other"}>
                  <option value="clubs_general">{tx["Clubs – general"]}</option>
                  <option value="clubs_quote">
                    {tx["Clubs – request a quote"]}
                  </option>
                  <option value="clubs_waiting_list">
                    {tx["Clubs – waiting list"]}
                  </option>
                  <option value="coaches_sparring_partners">
                    {tx["Coaches & sparring partners"]}
                  </option>
                  <option value="issue">{tx["Report an issue"]}</option>
                  <option value="stringers">{tx["Stringers"]}</option>
                  <option value="suggestions">
                    {tx["Suggestions and feedback"]}
                  </option>
                  <option value="work">{tx["Work opportunities"]}</option>
                  <option value="other">{tx["Other"]}</option>
                </select>
              </FormGroup>
              <FieldError fieldName="contact-reason" allErrors={allErrors} />
            </Col>
            <Col xs={12}>
              <FormGroup className="mb-3">
                <label className="form-label" htmlFor="contact-message">
                  * {tx["Message"]}
                </label>
                <textarea
                  id="contact-message"
                  className="form-control"
                  rows={5}
                />
              </FormGroup>
              <FieldError fieldName="contact-message" allErrors={allErrors} />
            </Col>
            <Col lg={6}>
              <Button className="w-100" onClick={onClick}>
                {tx["Send"]}
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </section>
  );
};

export default ContactForm;
